"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStagingEnvironment = exports.isProductionEnvironment = void 0;
var _includes = _interopRequireDefault(require("lodash/includes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var STAGING_HOSTS = ['veeggids.com'];
var PRODUCTION_HOSTS = ['swipeguide.com', 'swipeguide.cn'];
var isStagingEnvironment = exports.isStagingEnvironment = function isStagingEnvironment(hostname) {
  return STAGING_HOSTS.reduce(function (result, disabledHost) {
    return (0, _includes["default"])(hostname, disabledHost) || result;
  }, false);
};
var isProductionEnvironment = exports.isProductionEnvironment = function isProductionEnvironment(hostname) {
  return PRODUCTION_HOSTS.reduce(function (result, disabledHost) {
    return (0, _includes["default"])(hostname, disabledHost) || result;
  }, false);
};
//# sourceMappingURL=environment-utils.js.map